<script>
import ListingModel from "@/views/Notification/ControlProgram/Components/ListingModel.vue";

export default {
    name: "ControlProgramPage",
    components: {ListingModel},
}
</script>

<template>
    <ListingModel category="FILTER"/>
</template>

<style scoped>

</style>